import { createAction } from "@reduxjs/toolkit";

import { ActionTypes } from "./types";

export const request = createAction<void>(ActionTypes.REQUEST);
export const success = createAction<void>(ActionTypes.SUCCESS);
export const failure = createAction<void>(ActionTypes.FAILURE);
export const clean = createAction<void>(ActionTypes.CLEAN);
